export const VERA_FOLDER = 'VERA';
export const PROJECT_CATEGORY_FOLDER = 'projekt';

const INVALID_ONEDRIVE_CHARS = /["*:<>?/\\|]/g;

// An all-invalid title collapses to '-', not '': an empty segment resolves to the parent path.
export const sanitizeOneDriveSegment = (value: string): string => {
  const cleaned = value
    .replace(INVALID_ONEDRIVE_CHARS, '-')
    .trim()
    .replace(/\.+$/, '')
    .trim();
  return cleaned === '' ? '-' : cleaned;
};

export const PROJECT_CATEGORY_PATH = `/${VERA_FOLDER}/${PROJECT_CATEGORY_FOLDER}`;

export const projectFolderPath = (projectTitle: string): string =>
  `${PROJECT_CATEGORY_PATH}/${sanitizeOneDriveSegment(projectTitle)}`;

export const ensurePathsFor = (projectTitle: string): string[] => [
  `/${VERA_FOLDER}`,
  PROJECT_CATEGORY_PATH,
  projectFolderPath(projectTitle),
];

export const splitOneDrivePath = (
  path: string,
): { parent: string; name: string } => {
  const segments = path.split('/').filter(Boolean);
  const name = segments.pop() ?? '';
  return { parent: segments.length ? `/${segments.join('/')}` : '/', name };
};

// Graph answers 400 to a `remoteItem` create inside a subfolder; it must be created at the drive
// root and then moved.
export const SHORTCUT_CREATE_PATH = '/';
